var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22501 4.45002C3.45385 4.45002 4.45002 3.45385 4.45002 2.22501C4.45002 0.996171 3.45385 0 2.22501 0C0.996171 0 0 0.996171 0 2.22501C0 3.45385 0.996171 4.45002 2.22501 4.45002Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6742 4.45002C14.9031 4.45002 15.8992 3.45385 15.8992 2.22501C15.8992 0.996171 14.9031 0 13.6742 0C12.4454 0 11.4492 0.996171 11.4492 2.22501C11.4492 3.45385 12.4454 4.45002 13.6742 4.45002Z",
    fill: "#969696"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22501 14.8992C3.45385 14.8992 4.45002 13.9031 4.45002 12.6742C4.45002 11.4454 3.45385 10.4492 2.22501 10.4492C0.996171 10.4492 0 11.4454 0 12.6742C0 13.9031 0.996171 14.8992 2.22501 14.8992Z",
    fill: "#969696"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6742 14.8992C14.9031 14.8992 15.8992 13.9031 15.8992 12.6742C15.8992 11.4454 14.9031 10.4492 13.6742 10.4492C12.4454 10.4492 11.4492 11.4454 11.4492 12.6742C11.4492 13.9031 12.4454 14.8992 13.6742 14.8992Z",
    fill: "#969696"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22501 25.3504C3.45385 25.3504 4.45002 24.3542 4.45002 23.1254C4.45002 21.8966 3.45385 20.9004 2.22501 20.9004C0.996171 20.9004 0 21.8966 0 23.1254C0 24.3542 0.996171 25.3504 2.22501 25.3504Z",
    fill: "#969696"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6742 25.3504C14.9031 25.3504 15.8992 24.3542 15.8992 23.1254C15.8992 21.8966 14.9031 20.9004 13.6742 20.9004C12.4454 20.9004 11.4492 21.8966 11.4492 23.1254C11.4492 24.3542 12.4454 25.3504 13.6742 25.3504Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag-icon.5fb9ee7c8b066e3a5ae785a44c16abff.svg";
export { ForwardRef as ReactComponent };